/**
 * Anonyme Identität.
 *
 * Eine UUIDv4 im localStorage — kein Konto, kein Fingerprinting. Die zweite
 * Ablage als HttpOnly-Cookie und die Übertragung auf ein weiteres Gerät
 * kommen mit den Identitäts-Endpunkten in M4; bis dahin lebt sie nur hier.
 */

const SCHLUESSEL = 'mundart-anon-id'

function neu(): string {
  return crypto.randomUUID()
}

export function anonId(): string {
  try {
    const vorhanden = localStorage.getItem(SCHLUESSEL)
    if (vorhanden) return vorhanden
    const frisch = neu()
    localStorage.setItem(SCHLUESSEL, frisch)
    return frisch
  } catch {
    // Privater Modus oder geblockter Speicher: die Sitzung funktioniert
    // trotzdem, sie merkt sich nur nichts.
    return neu()
  }
}
